import { render, staticRenderFns } from "./MessageScreen.vue?vue&type=template&id=324cb209&scoped=true&"
import script from "./MessageScreen.vue?vue&type=script&lang=js&"
export * from "./MessageScreen.vue?vue&type=script&lang=js&"
import style0 from "./MessageScreen.vue?vue&type=style&index=0&id=324cb209&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324cb209",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('324cb209')) {
      api.createRecord('324cb209', component.options)
    } else {
      api.reload('324cb209', component.options)
    }
    module.hot.accept("./MessageScreen.vue?vue&type=template&id=324cb209&scoped=true&", function () {
      api.rerender('324cb209', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MessageScreen.vue"
export default component.exports